<template>
  <div class="page-box">
    <div class="head-box">
      <div class="info-box">
        <div class="company-name">{{companyInfo.companyName}}</div>
        <div class="tag" v-if="companyInfo.dictItemName">{{companyInfo.dictItemName}}</div>
        <p v-if="companyInfo.name">{{companyInfo.name}}</p>
        <p>{{companyInfo.phone}}</p>
        <p v-if="companyInfo.registerAddr">{{companyInfo.registerAddr}}</p>
        <p v-if="companyInfo.slogan">服务口号:{{companyInfo.slogan}}</p>
        <p v-if="companyInfo.introduce">公司简介:{{companyInfo.introduce}}</p>
      </div>
      <div>
        <img :src="imageUrl+companyInfo.logoUrl" alt="" class="logo-img" v-if="companyInfo.logoUrl">
      </div>
    </div>
    <a-tabs v-model="activeKey"  @change="tabChange">
      <a-tab-pane tab="公司荣誉" key="1">
        <div class='page-content'>
          <CompanyHonor />
        </div>
      </a-tab-pane>
      <a-tab-pane tab="经典案例" key="2">
        <div class='page-content'>
          <CompanyCases />
        </div>
      </a-tab-pane>
      <a-tab-pane tab="企业动态" key="3">
        <div class='page-content'>
          <CompanyTrends />
        </div>
      </a-tab-pane>
      <a-tab-pane tab="企业风采" key="4">
        <div class='page-content'>
          <CompanyStyle />
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import CompanyCases from './components/CompanyCases'
import CompanyTrends from './components/CompanyTrends'
import CompanyStyle from './components/CompanyStyle'
import CompanyHonor from './components/CompanyHonor'
import { company } from '@/api'
export default {
  name: 'PageCompanyDetail',
  components: {
    CompanyHonor,
    CompanyCases,
    CompanyTrends,
    CompanyStyle
  },
  data () {
    return {
      activeKey: '1',
      imageUrl: process.env.VUE_APP_IMG,
      // fileList: [],
      companyId: '',
      companyInfo: {}
    }
  },
  async mounted () {
    if (this.$route.params.id) {
      this.companyId = this.$route.params.id
    }
    await this.getDetail()
  },
  methods: {
    tabChange (key) {
      this.activeKey = key
    },
    async getDetail () {
      this.loading = true
      let { code, msg, data } = await company.getCompanyDetail({
        companyId: this.companyId
      })
      this.loading = false
      if (code !== 0) return this.$message.error(msg || '详情获取失败')
      this.companyInfo = data
      // if (data.logoPic) {
      //   this.fileList = data.logoPic.split(',').map(x => ({ uid: x, status: 'done', name: x, url: process.env.VUE_APP_IMG + x }))
      // }
    }
  }
}
</script>
<style lang="less" scoped>
  .page-box {
    padding: 0 32px;
    padding-top: 10px;
    /deep/ .table-box {
      border: none;
    }
  }
  .head-box {
    display: flex;
    padding: 14px 0;
    .info-box {
      width: 500px;
      .company-name {
        font-size: 36px;
        font-weight: 900;
        margin-bottom: 12px;
      }
      .tag {
        padding: 8px 16px;
        border: 1px solid blue;
        line-height: 16px;
        font-size: 16px;
        text-align: center;
        display: inline-block;
        margin-bottom: 14px;
      }
      p {
        font-size: 14px;
        line-height: 28px;
        /*color: #000;*/
      }
    }
    .logo-img {
      width: 200px;
      height: 200px;
      margin-left: 64px;
      margin-top: 14px;
    }

  }
</style>
